import React, { useEffect, useContext } from 'react';
import "./Styles/UserProfile.css";
import { Packs } from './Components/Context/PacksContext';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';
import BasketContextProvider from './Components/Context/BasketContext';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { initMercadoPago } from '@mercadopago/sdk-react';
import { useNavigate } from 'react-router-dom';

function OrderPendingRoute() {

    let publicKey = process.env.REACT_APP_MP_PUBLIC_KEY ? process.env.REACT_APP_MP_PUBLIC_KEY : "TEST-c2c23c3c-0b13-4388-97bd-699e852d4084"
    initMercadoPago(publicKey,{locale:'es-CL'});

    const {
        SetPurchased
    } = useContext(Packs);

    const Navigate = useNavigate();

    const MySwal = withReactContent(Swal)

    const queryString = window.location.search;
    const idPago = (new URLSearchParams(queryString)).get('paymentID');

    useEffect(() => {
        // Validate payment ID exists
        if (!idPago || idPago === 'null' || idPago === 'undefined') {
            MySwal.fire({
                icon: "error",
                title: "Error en el proceso de pago",
                text: "No se encontró el ID del pago. Por favor intente nuevamente.",
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(() => {
                Navigate("/orden-medica")
            });
            return;
        }

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Procesando el pago...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066", 
            customClass: 'swal-wide',
            showConfirmButton: false,
            allowOutsideClick: false,
            width: "100%",
        })

        let retryCount = 0;
        const maxRetries = 60; // Maximum 10 minutes (60 retries * 10 seconds)

        const interval = setInterval(() => {
            retryCount++;
            
            // Check if max retries reached
            if (retryCount > maxRetries) {
                clearInterval(interval);
                MySwal.fire({
                    icon: "warning",
                    title: "Tiempo de espera agotado",
                    text: "El pago está tomando más tiempo de lo esperado. Por favor revise el estado de su pago en el historial de órdenes o contacte a soporte.",
                    showConfirmButton: true,
                    allowOutsideClick: false
                }).then(() => {
                    Navigate("/orden-medica")
                });
                return;
            }

            fetch(`https://ymc-doc-api.azurewebsites.net/estado-pago/${idPago}`)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    return res.json();
                })
                .then(data => {
                    if (data.status === 'approved') {
                        clearInterval(interval);
                        SetPurchased(true)
                        MySwal.close()
                        Navigate("/orden-medica/descargar-orden")
                    } else if (data.status === 'rejected') {
                        clearInterval(interval);
                        MySwal.fire({
                            icon: "error",
                            title: "Tu pago fue rechazado",
                            text: "Por favor cambie los datos ingresados o inténtelo más tarde",
                            showConfirmButton: true,
                            allowOutsideClick: false
                        }).then(() => {
                            Navigate("/orden-medica")
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error checking payment status:", error);
                    // Don't clear interval on network errors, but stop after too many retries
                    if (retryCount > maxRetries) {
                        clearInterval(interval);
                        MySwal.fire({
                            icon: "error",
                            title: "Ocurrió un error al verificar el pago",
                            text: "Por favor revise el estado de su pago en el historial de órdenes o contacte a soporte.",
                            showConfirmButton: true,
                            allowOutsideClick: false
                        }).then(() => {
                            Navigate("/orden-medica")
                        });
                    }
                });
        }, 10000);
        return () => clearInterval(interval);
    }, [MySwal,Navigate,idPago,SetPurchased]);

    return (
        <UserInfoProvider>
            <BasketContextProvider>
                <MedicalContextProvider>
                    <div className="OrderPendingRoutePage">
                        <div className="OrderPendingRoute">
                            
                        </div>
                        {/*<div className="OrderPendingRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </BasketContextProvider>
        </UserInfoProvider>
    );
}

export default OrderPendingRoute;